import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import moment from 'moment';
import { AuthService } from '../../_services/auth.service';
import { ToastService } from '../../_services/toast.service';
import { UserService } from 'src/app/_services/user.service';


@Component({
  selector: 'app-add-availability-modal',
  templateUrl: './add-availability-modal.component.html',
  styleUrls: ['./add-availability-modal.component.scss'],
})
export class AddAvailabilityModalComponent implements OnInit {

  todayStart = moment().hours(10).minutes(0).seconds(0).format();
  todayEnd = moment().hours(18).minutes(0).seconds(0).format();
  user;

  loading = false;

  @Input() dates = [{days: [], startTime: this.todayStart, endTime: this.todayEnd}];;

  constructor(public modalCtrl: ModalController, private userService: UserService,
    private authService: AuthService, private toastService: ToastService) { }

  async ngOnInit() {
    this.user = await this.authService.getUser();
  }

  addOption() {
    this.dates.push({days: [], startTime: this.todayStart, endTime: this.todayEnd});
  }

  deleteDate(index: number) {
    this.dates.splice(index, 1);
  }

  async addAvailibility() {
    this.loading = true;
    let filterDates = this.dates.filter(d => d.days.length > 0).map((date: any) => {
      date.string = date.days.join();
      return date;
    });

    const availability = filterDates.reduce((res, date, index) => {
      res[`date${index + 1}`] = date;
      return res;
    }, {});

    try {
      const res = await this.userService.updateUserAvailability(
        this.user.companyLowercase,
        this.user.uid,
        availability
      );
      if (res) {
        this.toastService.present('Availability successfully added', 4000, 'bottom', 'checkmark-circle-outline', 'popup-slide');
        this.modalCtrl.dismiss({ dates: filterDates });
      }
    } catch (error) {
      console.error('Error updating availability:', error);
      this.toastService.present('Error adding availability. Please try again.', 4000, 'bottom', 'close-circle-outline', 'popup-slide');
    } finally {
      this.loading = false;
    }
  }

}
